// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"d9707570","453":"e8556bd4","714":"1c2482f3"}[chunkId] + ".chunk.js";
};